/* ============================================
   PRODUCT PAGE FIXES
   Quantity input capped to variant inventory
   ============================================ */
(function() {
  'use strict';

  if (!window.location.pathname.match(/\/products\//)) return;

  var inventoryData = null;
  var lastVariantId = null;

  function loadInventoryData() {
    var el = document.getElementById('pf-inventory-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function findVariantById(id) {
    if (!inventoryData || !inventoryData.variants) return null;
    id = parseInt(id, 10);
    for (var i = 0; i < inventoryData.variants.length; i++) {
      if (inventoryData.variants[i].id === id) return inventoryData.variants[i];
    }
    return null;
  }

  function getSelectedVariantId() {
    var sel = document.querySelector('select[name="id"], input[name="id"]');
    if (sel) return String(sel.value);
    var url = new URL(window.location.href);
    var v = url.searchParams.get('variant');
    return v ? String(v) : null;
  }

  function getQuantityInput() {
    return document.querySelector(
      'input[name="quantity"], ' +
      '.product-form__quantity input[type="number"], ' +
      '.quantity__input, ' +
      '.quantity-input input, ' +
      'input.quantity'
    );
  }

  function getMaxForVariant(variant) {
    if (!variant) return null;
    if (variant.inventory_management === null || variant.inventory_management === '') return null;
    if (variant.inventory_policy === 'continue') return null;
    return Math.max(0, variant.inventory_quantity);
  }

  function updateQuantityLimit() {
    var variantId = getSelectedVariantId();
    if (!variantId) return;

    var variant = findVariantById(variantId);
    var qtyInput = getQuantityInput();
    if (!qtyInput) return;

    if (variantId !== lastVariantId && lastVariantId !== null) {
      qtyInput.value = 1;
    }
    lastVariantId = variantId;

    var max = getMaxForVariant(variant);

    if (max !== null) {
      qtyInput.setAttribute('max', max);
      qtyInput.setAttribute('data-pf-max', max);
      qtyInput.min = 1;

      var val = parseInt(qtyInput.value, 10);
      if (val > max) qtyInput.value = max > 0 ? max : 1;
      if (max <= 0) {
        qtyInput.value = 0;
        qtyInput.setAttribute('disabled', 'disabled');
      } else {
        qtyInput.removeAttribute('disabled');
      }
    } else {
      qtyInput.removeAttribute('max');
      qtyInput.removeAttribute('data-pf-max');
      qtyInput.removeAttribute('disabled');
    }
  }

  function enforceQuantity(e) {
    var input = e.target;
    var max = parseInt(input.getAttribute('data-pf-max'), 10);
    if (isNaN(max)) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) { input.value = 1; return; }
    if (val > max) input.value = max > 0 ? max : 1;
  }

  function init() {
    inventoryData = loadInventoryData();
    if (!inventoryData) return;

    var qtyInput = getQuantityInput();
    if (qtyInput) {
      qtyInput.addEventListener('input', enforceQuantity);
      qtyInput.addEventListener('change', enforceQuantity);
      qtyInput.addEventListener('blur', enforceQuantity);
    }

    lastVariantId = getSelectedVariantId();
    updateQuantityLimit();

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.quantity__button, .js-qty-adjust, .qty-btn, [data-quantity-btn], button.plus, button.minus, .quantity-plus, .quantity-minus');
      if (!btn) return;
      setTimeout(function() {
        var qi = getQuantityInput();
        if (!qi) return;
        var max = parseInt(qi.getAttribute('data-pf-max'), 10);
        if (isNaN(max)) return;
        var val = parseInt(qi.value, 10);
        if (val > max) qi.value = max > 0 ? max : 1;
        if (val < 1 && max > 0) qi.value = 1;
      }, 50);
    });

    document.addEventListener('change', function(e) {
      if (e.target.name === 'id' || (e.target.type === 'radio' && e.target.closest('.product-form__input, fieldset, .variant-input'))) {
        setTimeout(updateQuantityLimit, 50);
      }
    });

    var variantInput = document.querySelector('select[name="id"], input[name="id"]');
    if (variantInput) {
      if (variantInput.tagName === 'SELECT') {
        variantInput.addEventListener('change', function() { setTimeout(updateQuantityLimit, 50); });
      }
      var observer = new MutationObserver(function() { setTimeout(updateQuantityLimit, 50); });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
